import { render, staticRenderFns } from "./PowerBI.vue?vue&type=template&id=1481961a&scoped=true"
import script from "./PowerBI.vue?vue&type=script&lang=js"
export * from "./PowerBI.vue?vue&type=script&lang=js"
import style0 from "./PowerBI.vue?vue&type=style&index=0&id=1481961a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481961a",
  null
  
)

export default component.exports